import React, { useEffect, useState, useRef } from 'react'

import { ScrollList } from '@hhgtech/hhg-components'
import { Text } from '@hhgtech/hhg-components/mantine'
import { Close } from '@hhgtech/icons/core'
import { ArrowLeft, ArrowRight } from '@hhgtech/icons/other'
// import {
//   ChevronRightWhiteIcon,
//   CloseIconWhite,
// } from 'components/organisms/graphicIndex/index.graphic'
// import { useSwipeClickFix } from 'hooks/useSwipeClickFix'
// import { styleRenderer } from 'plugins/styleRenderer'
// import { translationHandler } from 'plugins/translation'
import { Box, BoxProps, rem } from '@mantine/core'
import { useIntl } from 'react-intl'

// import { Text, BoxProps, Chip } from 'components/atoms/index'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { useIsMobile } from 'hooks/useIsMobile'
// import { ExtendingDataProps } from 'interfaces/types'

import {
  StyledMainImageContainer,
  StyledMainImage,
  StyledImageItemWrapper,
  StyledImageItemMoreOverlay,
  StyledPopup,
  StyledPopupCloseButton,
  StyledPopupLeftButton,
  StyledPopupRightButton,
  StyledPopupContentContainer,
  StyledMainImageWrapper,
  StyledBottomScrollListWrapper,
} from './index.styled'

export type Props = {
  /**
   * images
   */
  images: string[]
  currentImageIndex?: number
  setCurrentImageIndex?: (index: number) => void
  openPreviewImageIndex?: (index: number) => void
  isInPopup?: boolean
  productName?: string
  hideBottomScrollList?: boolean
  hideSeemore?: boolean
  url?: string
  /**
   * extending data props
   */
  // customDataProps?: ExtendingDataProps<CustomDataProps>
} & BoxProps

const ProductImageCarousel = ({
  images,
  currentImageIndex: currentImageIndexProp,
  setCurrentImageIndex: setCurrentImageIndexProp,
  openPreviewImageIndex,
  isInPopup,
  hideBottomScrollList,
  productName,
  hideSeemore,
  url,
}: Props) => {
  const currentUrl = useCurrentUrl()
  const { formatMessage: f } = useIntl()
  const [currentImageIndexState, setCurrentImageIndexState] = useState(
    currentImageIndexProp || 0,
  )
  const isMobile = useIsMobile()
  const carouselMax = !isInPopup ? 4 : isMobile ? 3 : 6
  const currentImageIndex =
    typeof currentImageIndexProp !== 'undefined'
      ? currentImageIndexProp
      : currentImageIndexState

  const setCurrentImageIndex = (i: number) => {
    setCurrentImageIndexState(i)
    if (typeof setCurrentImageIndexProp === 'function') {
      setCurrentImageIndexProp(i)
    }
  }

  // const {
  //   onMouseDown,
  //   onMouseMove,
  //   onClickCapture,
  //   onMouseOut,
  // } = useSwipeClickFix()
  const slicedImages = isInPopup ? images : images.slice(0, carouselMax)
  return (
    <Box
      sx={{
        '--carousel-max': carouselMax,
        display: 'flex',
        flexDirection: 'column',
        gap: rem(8),
        width: '100%',
      }}
    >
      <Box component="a" href={url} target="_blank">
        <StyledMainImageContainer data-in-popup={isInPopup}>
          {/* main image scroll view */}
          <StyledMainImageWrapper
          // onMouseDown={onMouseDown}
          // onMouseMove={onMouseMove}
          // onClickCapture={onClickCapture}
          // onMouseOut={onMouseOut}
          >
            <ScrollList
              key={images.length}
              row={1}
              column={1}
              page={currentImageIndex}
              isDotsShown={false}
              onChangePage={(p) => setCurrentImageIndex(p)}
              mode="snapped"
            >
              {images.map((image, index) => {
                return (
                  <StyledImageItemWrapper
                    key={index}
                    onClick={() => {
                      openPreviewImageIndex?.(index)
                    }}
                    // data-no-border
                    data-event-category="Ecommerce"
                    data-event-action="Product Image Click"
                    data-event-label={currentUrl}
                  >
                    <StyledMainImage
                      src={image}
                      alt={productName || `product image ${index + 1}`}
                      onError={(e) =>
                        (e.currentTarget.src = '/images/default-image.jpg')
                      }
                    />
                  </StyledImageItemWrapper>
                )
              })}
            </ScrollList>
          </StyledMainImageWrapper>
          <Box
            sx={(theme) => ({
              background: theme.colors.neutral100,
              padding: '2px 8px',
              position: 'absolute',
              bottom: 16,
              right: 16,
              borderRadius: 8,
            })}
          >
            <Text size="n1">{`${currentImageIndex + 1}/${images.length}`}</Text>
          </Box>
        </StyledMainImageContainer>
      </Box>

      {images.length > 1 && !hideBottomScrollList && (
        <StyledBottomScrollListWrapper data-in-popup={isInPopup}>
          <ScrollList
            key={images.length + '-' + carouselMax}
            row={1}
            column={carouselMax || 6}
            page={Math.floor(currentImageIndex / carouselMax)}
            isDotsShown={false}
            mode="snapped"
          >
            {slicedImages.map((image, index) => {
              const showSeeMore =
                index + 1 === carouselMax && !isInPopup && !hideSeemore
              return (
                <StyledImageItemWrapper
                  data-selected={index === currentImageIndex}
                  key={index}
                  onClick={() =>
                    showSeeMore
                      ? openPreviewImageIndex?.(index)
                      : setCurrentImageIndex(index)
                  }
                  data-event-category="Ecommerce"
                  data-event-action="Product Image Click"
                  data-event-label={currentUrl}
                >
                  <StyledMainImage
                    src={image}
                    onError={(e) =>
                      (e.currentTarget.src = '/images/default-image.jpg')
                    }
                  />
                  {showSeeMore && (
                    <StyledImageItemMoreOverlay>
                      <Text
                        size="n1"
                        // size="description"
                        // wordWrap="break-word"
                        // weight="regular"
                        sx={(theme) => ({
                          color: theme.fn.primaryColor(),
                        })}
                      >
                        {f({
                          id: 'productImageCarousel.seeAll',
                          defaultMessage: 'Xem tất cả',
                        })}
                      </Text>
                    </StyledImageItemMoreOverlay>
                  )}
                </StyledImageItemWrapper>
              )
            })}
          </ScrollList>
        </StyledBottomScrollListWrapper>
      )}
    </Box>
  )
}

const ProductImageCarouselPopup = ({
  images,
  isOpen,
  onClose,
  defaultCurrentImageIndex,
}: Props & {
  isOpen?: boolean
  onClose?: () => void
  defaultCurrentImageIndex?: number
}) => {
  const isMobile = useIsMobile()
  const [currentImageIndex, setCurrentImageIndex] = useState(
    defaultCurrentImageIndex || 0,
  )
  const popupContainerRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (isOpen) {
      setCurrentImageIndex(defaultCurrentImageIndex || 0)
    }
  }, [isOpen])

  useEffect(() => {
    const handleResize = () => {
      if (popupContainerRef.current) {
        const screenWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth
        const screenHeight =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight
        const getMin = (a: number, b: number) => (a < b ? a : b)
        const maxWidth = Math.round(
          getMin(0.65 * screenHeight, 0.9 * screenWidth),
        )
        popupContainerRef.current.style.maxWidth = maxWidth + 'px'
      }
    }

    window.addEventListener('resize', handleResize)
    setTimeout(handleResize, 500)
    setTimeout(handleResize, 1000)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  return (
    <StyledPopup data-open={isOpen}>
      <StyledPopupContentContainer ref={popupContainerRef}>
        <ProductImageCarousel
          images={images}
          currentImageIndex={currentImageIndex}
          setCurrentImageIndex={setCurrentImageIndex}
          isInPopup
        ></ProductImageCarousel>
      </StyledPopupContentContainer>
      <StyledPopupCloseButton onClick={onClose}>
        <Close size={24} color="#fff" />
      </StyledPopupCloseButton>
      {!isMobile && (
        <>
          <StyledPopupLeftButton
            onClick={() => setCurrentImageIndex((i) => (i > 0 ? i - 1 : i))}
          >
            <ArrowLeft size={24} color="#fff" />
          </StyledPopupLeftButton>
          <StyledPopupRightButton
            onClick={() =>
              setCurrentImageIndex((i) => (i + 1 < images.length ? i + 1 : i))
            }
          >
            <ArrowRight size={24} color="#fff" />
          </StyledPopupRightButton>
        </>
      )}
    </StyledPopup>
  )
}

export { ProductImageCarousel, ProductImageCarouselPopup }
